<template>
    <div>
        <el-header class="navbg">
            <div class="contBox">
                <hq-nav/>
            </div>
        </el-header>
        <el-main>
            <div class="NewsCont">
                <h1 class="btText">{{ bt }}</h1>
                <div class="text">
                    <div  v-for="(text,index) in newsCont.cont" :key="index">
                        <p>{{ text }}</p>
                        <div v-for="(imgs,imgID) in newsCont.img" :key="imgID">
                            <img v-if="imgs.id === index" :src="require('../assets/newsImg/' + imgs.src)" :alt="bt">
                        </div>
                    </div>
                </div>
            </div>
        </el-main>
        <el-footer class="footer news_footer">
            <hq-footer/>
        </el-footer>
    </div>
</template>

<script>
    import Nav from "./Nav";
    import Footer from "./Footer";

    export default {
        name: "NewsCont",
        data () {
            return{
                bt:"",
                newsCont: [],
                dataJson : require("../assets/JSON/NewsCont.json")
            };
        },
        created() {
            let type = this.$route.params.type;
            this.bt = this.$route.params.bt;
            this.newsCont = this.dataJson[type];
            console.log(this.dataJson[type]);
        },
        components:{
            "hq-nav":Nav,
            "hq-footer":Footer
        }
    }
</script>

<style scoped>
    .NewsCont .el-scrollbar{
        height: 100%;
    }
    .NewsCont{
        width: 85.5rem;
        min-height: calc(100vh - 17rem);
        margin: 0 auto;
        box-sizing: border-box;
        overflow: hidden;
        padding: 1rem 0;
    }
    .btText{
        color: #ffffff;
    }
    .text{
        width: 100%;
        height: auto;
        overflow: hidden;
        padding: 0 1rem;
        box-sizing: border-box;
    }
    .text p{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        font-size: 16px;
        font-family: AlibabaPuHuiTi;
        text-indent:35px;
        word-wrap:break-word;
        white-space: normal;
        overflow: hidden;
        text-align: left;
        color: #ffffff;
    }
    .text img{
        margin: 1rem 0;
    }
</style>